import { createAction, props } from "@ngrx/store";
import { LoadingState } from "./loading.state";

export const presentLoading = createAction(
    '[Loading] Present loading',
    props<{
        loadingKey: keyof LoadingState
    }>()
);

export const dismissLoading = createAction(
    '[Loading] Dismiss loading',
    props<{
        loadingKey: keyof LoadingState
    }>()
);

export const dismissAllLoading = createAction(
    '[Loading] Dismiss all loading'
);

export const pauseLoading = createAction(
    '[Loading] Pause loading'
);

export const resumeLoading = createAction(
    '[Loading] Resume loading'
);
